import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The Streamlit screen re-fetched everything on every click — eight requests to open a tab.
      // Here the cache is the default and only what is stale is asked for again.
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: false,
      // React Query pauses a query when `navigator.onLine` says the browser is offline, and then
      // it is neither loading nor failed — a screen waiting on data that will never arrive. That
      // flag lies often enough (VPNs, captive portals, corporate proxies) that we always attempt
      // the request: a real outage then surfaces as an error the analyst can read.
      networkMode: "always",
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
